module.exports = __webpack_public_path__ + "static/unresolved-title-879b60852a232a1a61c68b98ffdae575.mp4";